export const SPACE_REGEX =/\s/
//export const PASSWORD_REGX=/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/
export const PASSWORD_REGX=/^(?=.*[a-zA-Z])(?=.*\d)(?!.*[\u3040-\u30FF])(?!.*[\uFF01-\uFF5E])(?!.*[\uFF10-\uFF19]).{8,}$/

//export const FULLWIDTH_REGX=/^[\u4E00-\u9FFF]/
//export const FULLWIDTH_REGX=/[\uFF01-\uFF5E\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\u3041-\u3096\u30A1-\u30FA\u4E00-\u9FFF]/
export const FULLWIDTH_REGX=/^[\uFF21-\uFF3A\uFF41-\uFF5A\u3041-\u3096\u30A1-\u30FA\u4E00-\u9FFF\uFF10-\uFF19\u0030-\u0039\u30FC\u30FD\u30FEa-zA-Zー々]+$/

//export const KATAKANA_FULL_REGX=/^[\u30A1-\u30F6ー]+$/
export const KATAKANA_FULL_REGX=/^[\u30A1-\u30FA\uFF41-\uFF5A\uFF21-\uFF3A\u30FC\u30FD\u30FE\uFF10-\uFF190-9a-zA-Zー]+$/

/*export const EMAIL_REGEX1 =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,63}))$/*/
export const EMAIL_REGEX2 = /.*/;

export const EMAIL_REGEX1 =
/^(([^<>()\[\]\\.,;:\s@"]+|(".+"))(\.[^<>()\[\]\\.,;:\s@"]+|(".+"))*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,63}))$/

export const PARTICIPANT_EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+|(".+"))(\.[^<>()\[\]\\.,;:\s@"]+|(".+"))*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,7}))$/

export const  ENGLISH_REGEX = /^[a-zA-Z\s]+$/

export const ENGLISH_WITH_SPACE=/^[A-Za-z0-9\uFF10-\uFF19]+(?:\s[A-Za-z0-9\uFF10-\uFF19]+){0,2}$/

export const JAPANESE_REGEX=/(?=.*[\u3041-\u3096\u30A1-\u30FA\u4E00-\u9FFF\u30FC\u30FD\u30FEー々]).+/

export const KATAKANA_REGEX=/(?=.*[\u30A1-\u30FA\u30FC\u30FD\u30FEー])+/

export const SYMBOL_REGEX = /[!@#$%^&*(),.?":{}|<>]/

export const HALF_WIDTH_KATAKANA_REGEX = /[\uFF65-\uFF9F]/ 




